export default "__VITE_ASSET__8qgcki5V__"